import React from 'react';
import { bool, func, string, object } from 'prop-types';

import { connect } from 'react-redux';

import ConfirmActionModal from './ConfirmActionModal';

import * as ApplicationMessageActions from '../../actions/applicationMessageActions';
import * as ErpAgentActions from '../../actions/erpAgentActions';
import * as UiActions from '../../actions/uiActions';

const DeleteErpAgentModal = ({
    close,
    clearErrors,
    open,
    title,
    errors,
    isLoading,
    toggleLoading,
    selectedAgent,
    ...props
}) => {
    const handleDelete = async () => {
        const {
            companyInfo,
            deleteErpAgent
        } = props;

        let isDeleted;

        clearErrors();

        if (!isLoading) {
            toggleLoading(true);

            isDeleted = await deleteErpAgent(companyInfo.companyId, selectedAgent.id);

            if (isDeleted) handleClose();
        }
    };

    const handleClose = () => {
        toggleLoading(false);
        clearErrors();
        close();
    };

    if (!selectedAgent) return null;

    return (
        <ConfirmActionModal
            errors={errors}
            onClose={handleClose}
            onConfirm={handleDelete}
            open={open}
            title={title}
            isLoading={isLoading}
        >
            <p>
                If you delete this FSM Integration configuration you will lose all inventory items
                and links created in Architect associated with this FSM Integration
            </p>
            <p>
                Are you sure you want to delete Integration: {selectedAgent.name}?
            </p>
        </ConfirmActionModal>
    );
};

DeleteErpAgentModal.defaultProps = {
    selectedAgent: {}
};

DeleteErpAgentModal.propTypes = {
    close:         func.isRequired,
    open:          bool.isRequired,
    title:         string.isRequired,
    selectedAgent: object.isRequired
};

const mapStateToProps = ({ erpAgent, ...state }) => {
    const { selectedAgent } = erpAgent;

    return {
        companyInfo: state.companyInfo,
        errors:      state.messages.errors,
        isLoading:   state.ui.isLoading,
        selectedAgent
    };
};

const mapDispatchToProps = {
    ...ApplicationMessageActions,
    ...ErpAgentActions,
    ...UiActions
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteErpAgentModal);
